import * as Parse from 'parse';
import * as React from 'react';
import { RoutesModel, UserModel } from '../../../models';
import { Controllers } from '../../abstract';
import View from './CommonDashboardView';

export interface IAbstractDashboardControllerProps extends Interfaces.IViewControllerState {
    title: string
}

class AbstractDashboardController<P, S={}> extends Controllers.ViewController<P & IAbstractDashboardControllerProps, S> {

    public static defaultProps: Partial<IAbstractDashboardControllerProps> = {
        title: ''
    };

    public async componentWillMount() {
        if (Parse.User.current()) {
            let cSession = null;
            try {
                cSession = await Parse.Session.current();
            } catch (e) {
                console.log(e);
            }
            if (cSession) {
                if (!this.accessForRoles().length) {
                    throw new Error(`Определите роли для роута: ${this.props.location.pathname}`)
                }
                if (!this.props.title) {
                    throw new Error(`Укажите заголовок для роута: ${this.props.location.pathname}`)
                }
                this.setState({ loading: true })
                const userRole = await UserModel.Model.getRoleName();
                this.setState({ userRole, loading: false });
                if (this.accessAvailable) {
                    this.fia_componentWillMount();
                } else {
                    Object.keys(RoutesModel.Model).forEach(k => {
                        Object.keys(RoutesModel.Model[k]).forEach((kk, i) => {
                            const main = RoutesModel.Model[k].Main;
                            if ((k as any) === 0 && kk === 'Main' && UserModel.Model.checkRoleAccess(main.accessForRoles, userRole as string)) {
                                this.props.history['push'](main.route);
                            }
                        })
                    })
                }
            } else {
                await Parse.User.logOut();
                this.props.history['push']('/');
            }
        }
    }

    public fia_componentWillMount() {
        // ...
    }

    get accessAvailable() {
        return UserModel.Model.checkRoleAccess(this.accessForRoles(), this.state.userRole as string)
    }

    public goBack() {
        this.props.history['goBack']()
    }

    public dashboard_render(): JSX.Element {
        return <div>Hello dashboard!</div>
    }

    public async signOut() {
        await Parse.User.logOut()
        this.props.history['push']('/');
    }

    public accessForRoles() {
        let currentAccess: UserModel.Roles[] = [];
        Object.keys(RoutesModel).forEach(k => {
            Object.keys(RoutesModel[k]).forEach(kk => {
                Object.keys(RoutesModel[k][kk]).forEach(kkk => {
                    const result = RoutesModel[k][kk][kkk];
                    if (this instanceof result.controller) {
                        currentAccess = result.accessForRoles
                    }
                })
            })
        })
        return currentAccess
    }

    public telem_render(): JSX.Element {
        const { title } = this.props;
        return (
            <View
                routes={RoutesModel.Model}
                userRole={this.state.userRole}
                // tslint:disable-next-line:jsx-no-lambda
                signOut={() => this.signOut()}
                title={title}
            >
                {this.dashboard_render()}
            </View>
        );
    }
}

export default AbstractDashboardController;



// WEBPACK FOOTER //
// ./src/app/dashboard/common/CommonDashboardController.tsx